import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function writeAny(_this__u8e3s4, value) {
  if (value == null)
    _this__u8e3s4.nullValue_h3u4a2_k$();
  else {
    if (isInterface(value, KtMap())) {
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.beginObject_5wddq0_k$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = value.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'kotlin.collections.component1' call
        var key = element.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.component2' call
        var value_0 = element.get_value_j01efc_k$();
        _this__u8e3s4.name_i73qwh_k$(toString_0(key));
        writeAny(_this__u8e3s4, value_0);
      }
      _this__u8e3s4.endObject_ofuv3u_k$();
    } else {
      if (isInterface(value, KtList())) {
        // Inline function 'com.apollographql.apollo.api.json.writeArray' call
        _this__u8e3s4.beginArray_hxn19s_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = value.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          writeAny(_this__u8e3s4, element_0);
        }
        _this__u8e3s4.endArray_s2tmpq_k$();
      } else {
        if (typeof value === 'boolean')
          _this__u8e3s4.value_z3qus4_k$(value);
        else {
          if (typeof value === 'number')
            _this__u8e3s4.value_2irneh_k$(value);
          else {
            if (typeof value === 'bigint')
              _this__u8e3s4.value_hdgek3_k$(value);
            else {
              if (typeof value === 'number')
                _this__u8e3s4.value_pfghfv_k$(value);
              else {
                if (value instanceof JsonNumber())
                  _this__u8e3s4.value_pycfpt_k$(value);
                else {
                  if (typeof value === 'string')
                    _this__u8e3s4.value_hphtnt_k$(value);
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Cannot write ' + toString(value) + " of class '" + toString(getKClassFromExpression(value)) + "' to Json";
                    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
//region block: exports
export {
  writeAny as writeAny16i13331zbqlc,
};
//endregion

//# sourceMappingURL=JsonWriters.mjs.map
